module.exports = __webpack_public_path__ + "static/media/emoji-sad.3ab082bc.svg";